import { memo } from 'react';

import * as styles from './styles.module.scss';

/**
 0,0 is the bottom left corner for any landscape pitch
  1000 is the bottom right corner for any landscape pitch
  1000,1000 is the top right corner for any landscape pitch
  the scale or landscape pitch needs to respect ratio 105x68
   */

const getPosition = (c: { x: number; y: number }) => {
  if (!c) return { display: 'none' };

  const x = c.x / 10;
  const y = c.y / 10;
  return {
    top: `${y}%`,
    left: `${x}%`,
  };
};

export const GoalPosition = ({ data }: { data: { x: number; y: number }[] }) => {
  if (!data?.length) return null;

  return (
    <div className={styles.tsPositionPitch}>
      <ul>
        {data.map((c) => (
          <li key={`${c.x}_${c.y}`} className={styles.tsPositionGoal} style={getPosition(c)} />
        ))}
      </ul>
    </div>
  );
};

export default memo(GoalPosition);
